import React from 'react'
import {Helmet} from 'react-helmet-async';
import cafe2 from "../src/images/agartalaairportimages/cafe2.jpg";
import chitchaat from "../src/images/agartalaairportimages/chitchaat.jpg";
import chopchop from "../src/images/agartalaairportimages/chopchop.jpg";
import dossam from "../src/images/agartalaairportimages/dossam.jpg";
import icecream from "../src/images/agartalaairportimages/icecream.jpg";
import maggi from "../src/images/agartalaairportimages/maggi.jpg";
import nescafe from "../src/images/agartalaairportimages/nescafe.jpg";
import spicegrill from "../src/images/agartalaairportimages/spicegrill.jpg";


const Restaurant = () => {
  return (
    <>
    <Helmet>
      <title>Restaurants</title>
      <meta name='description' content="List of Restaurants at Coimbatore International Airport"/>
      <link rel="canonical" href="/restaurant"/>
    </Helmet>
    <table className="table table-striped table-hover table-bordered table-sm">
        <thead>
          <tr className="fs-5 fw-bold">
            <th scope="col ">Food Options</th>
            <th scope="col">About Us</th>
          </tr>
        </thead>
        <tbody className="table-group-divider">


          <tr>
            <td>
              <p className="fs-5 fw-bold">Spice Grill</p>
              <img
                className="img-thumbnail img-responsive"
                src={spicegrill}
                width="300"
                height="150"
                alt="skylite hotel"
              />
            </td>
            <td>Buffet System with Tasty Food <a href='9899803354'><button className='btn btn-primary'>Call Us</button></a></td>
          </tr>

          <tr>
            <td>
              <p className="fs-5 fw-bold">Cafe 2.0</p>
              <img
                className="img-thumbnail img-responsive"
                src={cafe2}
                width="300"
                height="150"
                alt="Fairfield By Marriott"
              />
            </td>
            <td>Buffet System with Tasty Food <a href='9899803354'><button className='btn btn-primary'>Call Us</button></a></td>
          </tr>

          <tr>
            <td>
              <p className="fs-5 fw-bold">Chit Chaat</p>
              <img
                className="img-thumbnail img-responsive"
                src={chitchaat}
                width="300"
                height="150"
                alt="The Residency"
              />
            </td>
            <td>Buffet System with Tasty Food <a href='9899803354'><button className='btn btn-primary'>Call Us</button></a></td>
          </tr>


          <tr>
            <td>
              <p className="fs-5 fw-bold">Chop Chop</p>
              <img
                className="img-thumbnail img-responsive"
                src={chopchop}
                width="300"
                height="150"
                alt="The Arcadia"
              />
            </td>
            <td>Buffet System with Tasty Food <a href='9899803354'><button className='btn btn-primary'>Call Us</button></a></td>
          </tr>

          <tr>
            <td>
              <p className="fs-5 fw-bold">Dossam</p>
              <img
                className="img-thumbnail img-responsive"
                src={dossam}
                width="300"
                height="150"
                alt="Gokulam Park"
              />
            </td>
            <td>5.2 Km</td>
          </tr>


          <tr>
            <td>
              <p className="fs-5 fw-bold">Ice Cream</p>
              <img
                className="img-thumbnail img-responsive"
                src={icecream}
                width="300"
                height="150"
                alt="Le-Meridien"
              />
            </td>
            <td>Buffet System with Tasty Food <a href='9899803354'><button className='btn btn-primary'>Call Us</button></a></td>
          </tr>

          
         

         
          <tr>
            <td>
              <p className="fs-5 fw-bold">Maggi</p>
              <img
                className="img-thumbnail img-responsive"
                src={maggi}
                width="300"
                height="150"
                alt="Le-Meridien"
              />
            </td>
            <td>Buffet System with Tasty Food <a href='9899803354'><button className='btn btn-primary'>Call Us</button></a></td>
          </tr>

         

          <tr>
            <td>
              <p className="fs-5 fw-bold">Nescafe</p>
              <img
                className="img-thumbnail img-responsive"
                src={nescafe}
                width="300"
                height="150"
                alt="Radisson blu"
              />
            </td>
            <td>Buffet System with Tasty Food <a href='9899803354'><button className='btn btn-primary'>Call Us</button></a></td>
          </tr>
         
          
        </tbody>
      </table>
    </>
  )
}

export default Restaurant